import React, { useEffect } from 'react';
import './RedirectionCard.css'; // Import the CSS file

const RedirectionCard = ({ onClose }) => {
  // Redirect to the installation guide after 15 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = './RadixInstallationGuide.pdf';
    }, 15000); // 15 seconds

    // Cleanup the timer if the component unmounts before redirection
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="redirection-overlay">
      <div className="redirection-card">
        <button className="close-button" onClick={onClose}>&times;</button>
        <h2>Download Installation Guide</h2>
        <p>Your download is in progress. The installation guide will open shortly.</p>
        
        <button onClick={() => window.location.href = './RadixInstallationGuide.pdf'}>
          Open Installation Guide
        </button>

      </div>
    </div>
  );
};

export default RedirectionCard;
